module.exports = __webpack_public_path__ + "static/img/notifications.e69d8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/notifications.png
// module id = 663
// module chunks = 8